import React, { useEffect, useState } from "react";
import { getFeedbackData, updateFeedback, downloadFeedbackReport } from "../../../action/feedback";
import CircularProgress from "@mui/material/CircularProgress";
import Alert from "../../layout/Alert";
import { setAlert } from "../../../action/alert";
import { connect } from "react-redux";
import { Box, Paper } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { useTheme } from "@mui/material/styles";
import { useDesignTokens } from "../../../theme/useDesignTokens";
import { selectMenuProps } from "../../../utils/selectMenuProps";
import EditIcon from "@mui/icons-material/Edit";
import MuiDatePicker from "../FormInputs/MuiDatePicker";
import FormInput from "../FormInputs/MuiTextField";
import Button from "../Button/Button";
import DataTable from "../DataTable/DataTable";
import IncrementalPagination from "../DataTable/IncrementalPagination";

const Feedback = ({ setCustomAlert, allowedDeviceCategories, allowCompanyBrand }) => {
  const theme = useTheme();
  const { colors } = useDesignTokens();
  const primaryColor = colors?.primary?.main || theme.palette.primary.main;
  
  const focusOutlineSx = {
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: `${primaryColor} !important`,
      borderWidth: "1px",
    },
    "& .MuiInputLabel-root.Mui-focused": {
      color: `${primaryColor} !important`,
    },
  };
  const typeFilters = [
    { label: "Select Type", value: undefined },
    { label: "Onboarding Failure", value: "ONBOARDING_FAILURE" },
    { label: "Control Failure", value: "CONTROL_FAILURE" },
    { label: "Device Offline", value: "DEVICE_OFFLINE" },
    { label: "New Feature", value: "NEW_FEATURE" },
    { label: "Product Info", value: "PRODUCT_INFO" },
    { label: "Warranty", value: "WARRANTY" },
    { label: "WIFI Update", value: "WIFI_UPDATE" },
    { label: "FW Upgrade", value: "FW_UPGRADE" },
    { label: "Device Offboarding", value: "DEVICE_OFFBOARDING" },
    { label: "Other", value: "OTHER" },
  ];
  const statusFilters = [
    { label: "Select Status", value: undefined },
    { label: "New", value: "NEW" },
    { label: "In-Progress", value: "IN-PROGRESS" },
    { label: "Closed", value: "CLOSED" },
  ];
  const headers = {
    type: "Type",
    deviceBrand: "Device Brand",
    deviceCategory: "Device Category",
    deviceId: "Device Id",
    mobile: "Mobile Number",
    description: "Description",
    status: "Status",
    comments: "Comments",
    errorCode: "Error Code",
    appVersion: "App Version",
    mobileOSVersion: "Mobile OS Version",
    mobileName: "Mobile Name",
    mobileModel: "Mobile Model",
    mobileOSBuildNumber: "Mobile OS Build Number",
    feedbackId: "Feedback Id",
    createdAt: "Created At",
    updatedAt: "Updated At",
  };

  const [feedbackData, setFeedbackData] = useState([]);
  const [typeFilter, setTypeFilter] = useState(undefined);
  const [categoryFilter, setCategoryFilter] = useState(undefined);
  const [brandFilter, setBrandFilter] = useState(undefined);
  const [statusFilter, setStatusFilter] = useState(undefined);
  const [mobileFilter, setMobileFilter] = useState(undefined);
  const [startDateFilter, setStartDateFilter] = useState(null);
  const [endDateFilter, setEndDateFilter] = useState(null);
  const [updateFlag, setUpdateFlag] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const pageSize = 20;
  const [lastApiPageFetched, setLastApiPageFetched] = useState(0);
  const [pageEndReached, setPageEndReached] = useState(false);

  const startIndex = pageSize * currentPage;
  const endIndex = startIndex + pageSize;

  const formateDate = (dateFilter) => {
    if (dateFilter) {
      const dateVal = dateFilter.getDate() < 10 ? `0${dateFilter.getDate()}` : dateFilter.getDate();
      const monthVal = dateFilter.getMonth() < 9 ? `0${dateFilter.getMonth() + 1}` : dateFilter.getMonth() + 1;
      return `${dateVal}${monthVal}${dateFilter.getFullYear()}`;
    }
  };

  const updateFeedbackData = (page, resolveFunc, errFunc) => {
    if (!resolveFunc) setIsLoading(true);
    getFeedbackData({
      deviceCategory: categoryFilter,
      deviceBrand: brandFilter,
      type: typeFilter,
      status: statusFilter,
      mobile: mobileFilter,
      startDate: formateDate(startDateFilter),
      endDate: formateDate(endDateFilter),
      page: page ?? lastApiPageFetched,
      size: pageSize * 5,
    })
      .then((res) => {
        if (!resolveFunc) setIsLoading(false);
        if (!resolveFunc) {
          if (res.length < pageSize * 5) {
            setPageEndReached(true);
          }
          setFeedbackData(res);
        } else {
          resolveFunc(res);
        }
      })
      .catch((err) => {
        if (!resolveFunc) setIsLoading(false);
        if (!errFunc) {
          console.log(err);
          setCustomAlert("Error while fetching data.");
        } else {
          errFunc(err);
        }
      });
  };

  const changeFeedBackValueInPage = (feedbackId, key, value) => {
    setFeedbackData((prev) => {
      const newData = [...prev];
      const index = newData.findIndex((item) => item.feedbackId === feedbackId);
      if (index > -1) {
        newData[index] = { ...newData[index], [key]: value };
      }
      return newData;
    });
  };

  const updateStatus = (feedbackId, status) => {
    updateFeedback(feedbackId, { status })
      .then(() => {
        changeFeedBackValueInPage(feedbackId, "status", status);
      })
      .catch((err) => setCustomAlert("There was an error while updating status."));
  };

  const udpateComments = (feedbackId, comments, status) => {
    updateFeedback(feedbackId, { comments, status })
      .then(() => {
        changeFeedBackValueInPage(feedbackId, "comments", comments);
      })
      .catch((err) => {
        setCustomAlert("There was an error while updating comments.");
      });
  };

  useEffect(() => {
    updateFeedbackData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateFlag]);

  const reset = () => {
    setTypeFilter(undefined);
    setCategoryFilter(undefined);
    setBrandFilter(undefined);
    setStatusFilter(undefined);
    setMobileFilter(undefined);
    setStartDateFilter(null);
    setEndDateFilter(null);
    filter();
  };

  const filter = () => {
    setCurrentPage(0);
    setPageEndReached(false);
    setLastApiPageFetched(0);
    setUpdateFlag(Math.random());
  };

  const handleStartDateChange = (date) => {
    setStartDateFilter(date);
  };
  const handleEndtDateChange = (date) => {
    setEndDateFilter(date);
  };
  
  const handleDownloadFeedback = () => {
    downloadFeedbackReport({
      deviceCategory: categoryFilter,
      deviceBrand: brandFilter,
      type: typeFilter,
      status: statusFilter,
      startDate: formateDate(startDateFilter),
      endDate: formateDate(endDateFilter),
    });
  };

  const handlePageChange = (newPage) => {
    if (newPage < 0) {
      return;
    }

    const loadedPageCount = Math.ceil(feedbackData.length / pageSize);

    if (newPage < loadedPageCount) {
      setCurrentPage(newPage);
      return;
    }

    if (pageEndReached) {
      return;
    }

    setIsLoading(true);
    updateFeedbackData(
      lastApiPageFetched + 1,
      (data) => {
        setIsLoading(false);
        if (data.length < pageSize * 5) {
          setPageEndReached(true);
        }
        if (data.length === 0) {
          // No snackbar on end-of-data; just lock pagination state.
          setPageEndReached(true);
          return;
        }
        setFeedbackData((prev) => [...prev, ...data]);
        setLastApiPageFetched((prev) => prev + 1);
        setCurrentPage(newPage);
      },
      () => {
        setIsLoading(false);
        setCustomAlert("Error while fetching data.");
      }
    );
  };

  const handlePageSizeChange = (newSize) => {
    // Page size is fixed to 20 to match dealer-management incremental loading behavior.
  };

  const columns = [
    {
      key: "slNo",
      label: "Sl.No",
    },
    ...Object.keys(headers).map((key) => {
      let col = {
        key,
        label: headers[key],
      };
      if (key === "status") {
        // "In-Progress" is the longest value; ensure the column can fit it without spilling
        // into the adjacent "Comments" cell.
        col.minWidth = 170;
        col.render = (val, row) => (
          <Box sx={{ width: "100%", minWidth: 0 }}>
            <FormInput
              type="select"
              size="small"
              fullWidth
              className="custom-select select-reset"
              disabled={val === "CLOSED"}
              value={val}
              onChange={(e) => updateStatus(row.feedbackId, e.target.value)}
              options={statusFilters}
              MenuProps={selectMenuProps}
              sx={{
                minWidth: 0,
                width: "100%",
                maxWidth: "100%",
                "& .MuiInputBase-root": {
                  minWidth: 0,
                },
              }}
            />
          </Box>
        );
      } else if (key === "comments") {
        col.render = (val, row) => {
          let commentInputId = row.feedbackId + "Comment";
          if (row.showCommentEdit) {
            return (
              <Box sx={{ width: 250, minWidth: 200, display: "block" }}>
                <FormInput
                  size="small"
                  fullWidth
                  sx={{
                    ...focusOutlineSx,
                    "& .MuiInputBase-input": {
                      height: "36px !important",
                      padding: "0 14px !important",
                    },
                    "& .MuiOutlinedInput-root": {
                      height: "36px !important",
                      minHeight: "36px !important",
                    }
                  }}
                  value={row.comments || ""}
                  id={commentInputId}
                  autoFocus
                  onChange={(e) => changeFeedBackValueInPage(row.feedbackId, "comments", e.target.value)}
                  onBlur={() => {
                    changeFeedBackValueInPage(row.feedbackId, "showCommentEdit", false);
                    udpateComments(row.feedbackId, row.comments, row.status);
                  }}
                />
              </Box>
            );
          } else {
            return (
              <Box
                sx={{ display: "flex", alignItems: "center", cursor: "pointer", minHeight: "36px", minWidth: 200, maxWidth: 300 }}
                onClick={() => {
                  if (row.status === "NEW") {
                    setCustomAlert("Comments are editable if status is closed.");
                    return;
                  }
                  changeFeedBackValueInPage(row.feedbackId, "showCommentEdit", true);
                }}
              >
                {!row.comments ? (
                  <EditIcon 
                    sx={{ 
                      ml: 2.5, 
                      color: row.status !== "NEW" ? "warning.main" : "text.disabled",
                      cursor: "pointer",
                      fontSize: 20
                    }} 
                  />
                ) : (
                  <span style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{row.comments}</span>
                )}
              </Box>
            );
          }
        };
      } else if (key === "description") {
        col.render = (val) => (
          <Box sx={{ minWidth: 300, whiteSpace: "normal", wordBreak: "break-word" }}>
            {val}
          </Box>
        );
      } else {
        col.render = (val) => (
          <span style={{ wordBreak: String(val).length > 50 ? "break-word" : "normal", whiteSpace: String(val).length > 50 ? "normal" : "nowrap" }}>
            {val}
          </span>
        );
      }
      return col;
    }),
  ];

  const tableData = feedbackData.slice(startIndex, endIndex).map((row, index) => ({
    ...row,
    slNo: startIndex + index + 1,
  }));

  if (isLoading && feedbackData.length === 0) {
    return (
      <div style={{ display: "grid", placeItems: "center", height: "80vh" }}>
        <CircularProgress size="5em" style={{ color: "#AFB42B" }} />
      </div>
    );
  }

  return (
    <Box sx={{ width: "100%", maxWidth: "100%", mx: 0, boxSizing: "border-box" }}>
      <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1, mb: 2 }}>
        <Box sx={{ pt: 1, pb: 1.5, px: 0 }}>
          <Grid2 container spacing={2} sx={{ mb: 0 }}>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <FormInput
                type="select"
                size="small"
                fullWidth
                className="custom-select select-reset"
                value={typeFilter ?? ""}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value === "" || value === typeFilters[0].label) value = undefined;
                  setTypeFilter(value);
                }}
                displayEmpty
                renderValue={(v) => (v == null || v === "" ? typeFilters[0].label : typeFilters.find((f) => f.value === v)?.label ?? v)}
                options={typeFilters.map((element) => ({ value: element.value ?? "", label: element.label }))}
                MenuProps={selectMenuProps}
                sx={focusOutlineSx}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <FormInput
                type="select"
                size="small"
                fullWidth
                className="custom-select select-reset"
                value={categoryFilter ?? ""}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value === "" || value === "Select Category") value = undefined;
                  setCategoryFilter(value);
                }}
                displayEmpty
                renderValue={(v) => v || "Select Category"}
                options={[
                  { value: "", label: "Select Category" },
                  ...(allowedDeviceCategories || []).map((element) => ({ value: element, label: element })),
                ]}
                MenuProps={selectMenuProps}
                sx={focusOutlineSx}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <FormInput
                type="select"
                size="small"
                fullWidth
                className="custom-select select-reset"
                value={brandFilter ?? ""}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value === "" || value === "Select Brand") value = undefined;
                  setBrandFilter(value);
                }}
                displayEmpty
                renderValue={(v) => v || "Select Brand"}
                options={[
                  { value: "", label: "Select Brand" },
                  ...(allowCompanyBrand || []).map((element) => ({ value: element, label: element })),
                ]}
                MenuProps={selectMenuProps}
                sx={focusOutlineSx}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <FormInput
                type="select"
                size="small"
                fullWidth
                className="custom-select select-reset"
                value={statusFilter ?? ""}
                onChange={(e) => {
                  let value = e.target.value;
                  if (value === "" || value === statusFilters[0].label) value = undefined;
                  setStatusFilter(value);
                }}
                displayEmpty
                renderValue={(v) => (v == null || v === "" ? statusFilters[0].label : statusFilters.find((f) => f.value === v)?.label ?? v)}
                options={statusFilters.map((element) => ({ value: element.value ?? "", label: element.label }))}
                MenuProps={selectMenuProps}
                sx={focusOutlineSx}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <MuiDatePicker
                label="Start Date"
                value={startDateFilter}
                maxDate={new Date()}
                onChange={handleStartDateChange}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
              <MuiDatePicker
                label="End Date"
                value={endDateFilter}
                maxDate={new Date()}
                onChange={handleEndtDateChange}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  flexWrap: { xs: "wrap", sm: "nowrap" },
                  minHeight: 40,
                }}
              >
                <Button
                  variant="primary"
                  size="medium"
                  onClick={filter}
                  sx={{ flexShrink: 0, width: { xs: "calc(50% - 6px)", sm: "auto" } }}
                >
                  Filter
                </Button>
                <Button
                  variant="ghost"
                  size="medium"
                  onClick={reset}
                  sx={{ flexShrink: 0, width: { xs: "calc(50% - 6px)", sm: "auto" } }}
                >
                  Reset
                </Button>
                <Button
                  variant="primary"
                  size="medium"
                  onClick={handleDownloadFeedback}
                  sx={{ flexShrink: 0, width: { xs: "100%", sm: "auto" } }}
                >
                  Download
                </Button>
              </Box>
            </Grid2>
          </Grid2>
        </Box>
      </Paper>
      <Alert />
      <Paper sx={{ p: 2, boxShadow: 2, borderRadius: 1 }}>
        <Grid2 container sx={{ mb: -2 }}>
          <Grid2 size={12}>
            {isLoading && feedbackData.length > 0 && (
              <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
                <CircularProgress size="2rem" />
              </Box>
            )}
            <DataTable 
              columns={columns} 
              data={tableData} 
              rowKey="feedbackId" 
              maxHeight="calc(100dvh - 350px)"
              minWidth="1200px" 
            />
            <IncrementalPagination
              page={currentPage}
              pageSize={pageSize}
              dataLength={feedbackData.length}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              pageSizeOptions={[pageSize]}
              isLastPage={pageEndReached && endIndex >= feedbackData.length}
            />
          </Grid2>
        </Grid2>
      </Paper>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  allowedDeviceCategories: state.auth.allowedDeviceCategories,
  allowCompanyBrand: state.auth.allowCompanyBrand,
});

const mapDispatchToProps = (dispatch) => ({
  setCustomAlert: (message) => dispatch(setAlert(message, "error")),
});

export default connect(mapStateToProps, mapDispatchToProps)(Feedback);
